export default "__VITE_ASSET__o2DVQhvS__"